module.exports = __webpack_public_path__ + "img/7-1.dddcf87b.png";